<template>
  <v-container class="px-6 pt-0 pb-3" style="max-width: 100%">
    <v-dialog v-model="save_view" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Save Bookmark</span>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="view_name_tmp"
            hint="Bookmark Name"
            persistent-hint
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" outlined @click="close_save_view_func()"> Cancel </v-btn>
          <v-btn color="black" outlined @click="add_view()"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row class="ma-0 pa-0" style="width: 100%; height: 100%">
      <v-col
        :cols="
          (toolbar_visible || views_visible) && portfolio_type != 'performance' ? 9 : 12
        "
        style="width: 100%"
        v-if="tbl_avaialable"
      >
        <v-row class="ma-0 pa-0">
          <v-col cols="7" class="ma-0 pa-0">
            <v-chip
              label
              class="data_breakdown_chip"
              :outlined="portfolio_type != 'portfolio'"
              @click="portfolio_type = 'portfolio'"
              color="black"
            >
              Portfolio
            </v-chip>
            <v-chip
              label
              class="data_breakdown_chip"
              :outlined="portfolio_type != 'performance'"
              @click="
                chart_update_key++;
                portfolio_type = 'performance';
              "
              color="black"
            >
              Performance
            </v-chip>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" class="ma-0 pa-0">
            <v-menu offset-y v-if="portfolio_type != 'performance'">
              <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                <v-tooltip top>
                  <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                    <v-btn 
                      icon
                      v-bind="{ ...menuAttrs, ...tooltipAttrs }"
                      v-on="{ ...menuOn, ...tooltipOn }"
                    >
                      <v-icon color="black">mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <TooltipDescription title="Download" desc_2=""></TooltipDescription>
                </v-tooltip>
              </template>

              <v-list>
                <v-list-item-group v-model="selectedExportItem" color="primary">
                  <v-list-item v-for="(item, i) in exportOptions" :key="i" link>
                    <v-list-item-content @click="exportSelected(item.id)">
                      <v-list-item-title v-text="item.title"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>



            <v-tooltip top v-if="views_visible && portfolio_type != 'performance'">
              <template v-slot:activator="{ on }">
                <v-btn icon elevation="0" v-on="on" @click="views_visible = false">
                  <v-icon color="black">mdi-bookmark-off</v-icon>
                </v-btn>
              </template>
              <TooltipDescription title="Hide Bookmarks" desc_2=""></TooltipDescription>
            </v-tooltip>
            <v-tooltip top v-if="!views_visible && portfolio_type != 'performance'">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  elevation="0"
                  v-on="on"
                  @click="
                    views_visible = true;
                    toolbar_visible = false;
                  "
                >
                  <v-icon color="black">mdi-bookmark-outline</v-icon>
                </v-btn>
              </template>
              <TooltipDescription title="Bookmarks" desc_2=""></TooltipDescription>
            </v-tooltip>

            <v-tooltip top v-if="toolbar_visible && portfolio_type != 'performance'">
              <template v-slot:activator="{ on }">
                <v-btn icon elevation="0" v-on="on" @click="toolbar_visible = false">
                  <v-icon color="black">mdi-filter-off</v-icon>
                </v-btn>
              </template>
              <TooltipDescription title="Hide Toolbar" desc_2=""></TooltipDescription>
            </v-tooltip>
            <v-tooltip top v-if="!toolbar_visible && portfolio_type != 'performance'">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  elevation="0"
                  v-on="on"
                  @click="
                    toolbar_visible = true;
                    views_visible = false;
                  "
                >
                  <v-icon color="black">mdi-filter-settings-outline</v-icon>
                </v-btn>
              </template>
              <TooltipDescription title="Toolbar" desc_2=""></TooltipDescription>
            </v-tooltip>
          </v-col>
          <v-col
            cols="12"
            class="ma-0 pa-0"
            :style="{
              display: portfolio_type == 'portfolio' ? 'block' : 'none',
            }"
          >
            <DataLevelTable
              :tableHeader="headers"
              :tableData="performanceData"
              :selectedLevels="selected_levels"
              :tableRowClickFunction="handle_row_click"
              :numericColumns="numericColumns"
              :currencyColumns="currencyColumns"
              :percentageColumns="percentageColumns"
              :reversedPercentageColorColumns="reversedPercentageColorColumns"
              :decimalColumns="[]"
              v-on:filter_data="filter_added"
              :filterable="filter_toggle"
              :data_filters="data_filters"
              :filter_all_vals="filter_base_values"
            />
          </v-col>
          <v-col
            cols="12"
            class="ma-0 pa-0"
            :style="{display: portfolio_type == 'performance' ? 'block' : 'none'}"
            style="height: calc(100vh - 300px); overflow-y: scroll;"
          >
            <PerformanceOverview
              :data_levels="selected_levels"
              :project_date_range="project_date_range"
              :project_filters="data_filters"
              :chart_mapping="chart_mapping"
              ref="performance_overview"
              :chart_update_key="chart_update_key"
              v-on:update_export_ready="update_export_ready"
            ></PerformanceOverview>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" style="width: 100%; height: 100%; max-height: 550px" v-else>
        <v-row class="ma-0 pa-0" justify="center" :align="'center'" style="height: 100%">
          <v-col cols="auto" class="ma-0 pa-0">
            <v-progress-circular
              size="100"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="3"
        style="height: 100%"
        v-if="views_visible && portfolio_type != 'performance' && tbl_avaialable"
      >
        <v-card style="height: calc(100vh - 325px); max-height: calc(100vh - 325px); overflow-y: scroll">
          <v-card-title>
            <v-row class="ma-0 pa-0">
              <v-col sm="2" md="auto" class="ma-0 pa-0">
                <v-icon class="ml-0 mr-3" color="black">mdi-bookmark-outline</v-icon>
              </v-col>
              <v-col
                cols="6"
                class="ma-0 pa-0"
                style="text-overflow: ellipsis !important"
              >
                <span class="toolbar_title">Bookmarks</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="ma-0 pa-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn icon elevation="0" v-on="on" @click="refresh_views">
                      <v-icon color="black">mdi-reload</v-icon>
                    </v-btn>
                  </template>
                  <TooltipDescription title="Refresh" desc_2=""></TooltipDescription>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-row style="width: 100%" class="ma-0 pa-0" align="center" justify="center">
            <v-col cols="auto" v-if="views_loading">
              <v-progress-circular
                size="100"
                indeterminate
                color="black"
              ></v-progress-circular>
            </v-col>
            <v-col cols="12" v-else>
              <v-list style="width: 100%" rounded>
                <v-list-item-group v-model="selected_view">
                  <v-list-item v-for="(view, idx) in available_views" :key="idx">
                    <v-list-item-icon>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            elevation="0"
                            v-on="on"
                            @click="delete_view(view.id)"
                          >
                            <v-icon color="black">mdi-bookmark-remove-outline</v-icon>
                          </v-btn>
                        </template>
                        <TooltipDescription
                          title="Delete Bookmark"
                          desc_2=""
                        ></TooltipDescription>
                      </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-title>{{ view.name }}</v-list-item-title>
                    <v-list-item-icon>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn icon elevation="0" v-on="on" @click="open_view(idx)">
                            <v-icon color="black">mdi-open-in-app</v-icon>
                          </v-btn>
                        </template>
                        <TooltipDescription
                          title="Open Bookmark"
                          desc_2=""
                        ></TooltipDescription>
                      </v-tooltip>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col
        cols="3"
        style="height: 100%"
        v-if="toolbar_visible && portfolio_type != 'performance' && tbl_avaialable"
      >
        <v-card
          style="
            height: calc(100vh - 325px);
            max-height: calc(100vh - 325px);
            overflow-y: scroll;
          "
        >
          <v-card-title>
            <v-row class="ma-0 pa-0">
              <v-col sm="2" md="auto" class="ma-0 pa-0">
                <v-icon class="ml-0 mr-3" color="black">mdi-hammer-screwdriver</v-icon>
              </v-col>
              <v-col
                cols="6"
                class="ma-0 pa-0"
                style="text-overflow: ellipsis !important"
              >
                <span class="toolbar_title">Toolbar</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="ma-0 pa-0">
                <v-tooltip top v-if="selected_view == null">
                  <template v-slot:activator="{ on }">
                    <v-btn icon elevation="0" v-on="on" @click="save_view_func">
                      <v-icon color="black">mdi-bookmark-plus-outline</v-icon>
                    </v-btn>
                  </template>
                  <TooltipDescription title="Add Bookmark" desc_2=""></TooltipDescription>
                </v-tooltip>
                <v-tooltip top v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn icon elevation="0" v-on="on" @click="reset_view">
                      <v-icon color="black">mdi-bookmark</v-icon>
                    </v-btn>
                  </template>
                  <TooltipDescription
                    title="Bookmarked"
                    desc_2="(click to reset)"
                  ></TooltipDescription>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-col cols="12">
            <v-select
              class="toolbar_selector"
              disabled
              :value="data_version"
              label="Data Version"
              hint="The data version of the blocking chart"
              persistent-hint
              :items="[data_version]"
              @change="reset_table()"
            ></v-select>
          </v-col>
          <v-row style="width: 100%" class="ma-0 pa-0">
            <v-col cols="12">
              <v-combobox
                v-model="selected_levels_tmp"
                :items="available_data_levels"
                label="Levels"
                multiple
                chips
                @input="update_levels_debounce"
              >
                <template v-slot:selection="data">
                  <v-chip
                    :key="JSON.stringify(data.item)"
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    :disabled="data.disabled"
            >
                    <v-avatar
                      class="black white--text"
                      left
                      v-text="data.index + 1 "
                    ></v-avatar>
                    {{ data.item }}
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            <DateRange
              :start_date="start_date"
              :end_date="end_date"
              :min_start_date="project_date_range['min_start_date']"
              :max_end_date="project_date_range['max_end_date']"
              v-on:start_date_update="update_start_date"
              v-on:end_date_update="update_end_date"
              v-on:date_update="update_date"
              ref="date_range_comp"
            ></DateRange>
            <v-col cols="12">
              <v-select
                class="toolbar_selector ma-0 pa-0"
                v-model="selected_fields"
                :items="data_fields"
                label="Fields"
                multiple
                hint="Pick the data fields you wish to view."
                persistent-hint
                chips
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span class="actionText">{{ item }}</span>
                  </v-chip>
                  <v-chip v-if="index === 1">
                    <span class="actionText">{{ item }}</span>
                  </v-chip>
                  <v-chip v-if="index === 2">
                    <span class="actionText">{{ item }}</span>
                  </v-chip>
                  <span v-if="index === 3" class="grey--text text-caption">
                    (+{{ selected_fields.length - 3 }} others)
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-switch
                class="toolbar_selector ma-0 pa-0"
                v-model="filter_toggle"
                label="Filter"
              ></v-switch>
              <v-switch
                class="toolbar_selector ma-0 pa-0"
                v-model="compare"
                label="Compare"
                @change="refresh_compare_data()"
              ></v-switch>
              <DateRange
                v-if="compare"
                :start_date="compare_start_date"
                :end_date="compare_end_date"
                :min_start_date="project_date_range['min_start_date']"
                :max_end_date="project_date_range['max_end_date']"
                v-on:start_date_update="update_compare_start"
                v-on:end_date_update="update_compare_end"
                v-on:date_update="update_compare_date"
              ></DateRange>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TooltipDescription from "@/components/Utility/TooltipDescription.vue";
import DataLevelTable from "@/components/Utility/DataLevelTable.vue";
import DateRange from "@/components/Utility/DateRange.vue";
import {
  ALERT_TYPE_ERROR,
  ALERT_GENERIC_MESSAGE,
  PERFORMANCE_TABLE_CURRENCY_COLUMNS,
  PERFORMANCE_TABLE_NUMERIC_COLUMNS,
  PERFORMANCE_TABLE_PERCENTAGE_COLUMNS,
} from "@/constants/constants";

import PerformanceOverview from "@/components/Performance/PerformanceStats/PerformanceOverview.vue";

import api_caller from "@/javascript/data_retrieval.js";
import info_caller from "@/javascript/data_info.js";
import debounce from "lodash.debounce";
import * as echarts from "echarts";
import { DELAY, EXPORT_DELAY_IN_MS } from "@/constants/constants.js";
import * as ExcelJS from "exceljs";
import * as FileSaver from "file-saver";

const CHART_MAPPING = {
  portfolio_sos_chart: {
    chart_ref: "portfolio_sos_chart",
    chart_id: "portfolio_sos_chart",
    chart_name: "Portfolio Share of Sales Chart",
  },
  portfolio_time_series_comparison_chart: {
    chart_ref: "portfolio_time_series_comparison_chart",
    chart_id: "portfolio_time_series_comparison_chart",
    chart_name: "Time Series Contribution Comparison",
  },
  portfolio_volume_vs_efficiency_chart: {
    chart_ref: "portfolio_volume_vs_efficiency_chart",
    chart_id: "portfolio_volume_vs_efficiency_chart",
    chart_name: "Volume vs Efficiency",
  },
  portfolio_roas_contribution_chart: {
    chart_ref: "portfolio_roas_contribution_chart",
    chart_id: "portfolio_roas_contribution_chart",
    chart_name: "ROAS Contribution",
  },
  portfolio_total_units_vs_cpu_chart: {
    chart_ref: "portfolio_total_units_vs_cpu_chart",
    chart_id: "portfolio_total_units_vs_cpu_chart",
    chart_name: "Total Units VS Cost Per Unit",
  },
};

const EXPORT_MESSAGE_PORTFOLIO = "Exporting Portfolio page";
const EXPORT_MESSAGE_PERFORMANCE = "Exporting Performance page";

export default {
  name: "PerformanceStatsTable",
  props: ["data_version", "data_levels", "project_date_range"],
  components: {
    TooltipDescription,
    DataLevelTable,
    DateRange,
    PerformanceOverview,
  },
  data: () => ({
    performanceDataRaw: null,
    performanceData: [],
    compareDataRaw: null,
    compare_data: null,
    selected_levels: [],
    selected_levels_tmp: [],
    selected_fields: [
      "ROI",
      "Cost per Enrollment",
      "Enrollments",
      "Sales Attribution",
      "Units",
      "CPU",
      "Spend",
      "Impressions",
      "CPM",
      "Avg Daily CPM",
      "Clicks",
      "CPC",
      "Avg Daily CPC",
      "CTR",
      "Avg Daily CTR",
      "Reach",
      "Frequency",
    ],
    selected_sort_keys: [],
    tbl_avaialable: false,
    toolbar_visible: true,
    portfolio_type: "portfolio",

    available_data_levels: [],

    data_filters: {},

    views_visible: false,
    views_loading: true,
    selected_view: null,
    save_view: false,
    view_name_tmp: "",
    available_views: [],

    compare: false,
    filter_toggle: false,
    compare_start_date: null,
    compare_end_date: null,

    fields_updates: 0,
    chart_update_key: 0,

    chart_mapping: CHART_MAPPING,
    currencyColumns: PERFORMANCE_TABLE_CURRENCY_COLUMNS,
    numericColumns: PERFORMANCE_TABLE_NUMERIC_COLUMNS,
    percentageColumns: PERFORMANCE_TABLE_PERCENTAGE_COLUMNS,
    reversedPercentageColorColumns: [
      "cpm change",
      "cpu change",
      "cpm_change",
      "cpu_change",
    ],

    start_date: null,
    end_date: null,

    filter_base_values: {},

    selectedExportItem: null,
    exportOptions: [
      { title: "Export PPTX", id: "export_pptx" },
      { title: "Export XLSX", id: "export_xlsx" },
    ],
    graph_export_ready: false,
  }),
  mounted() {
    this.refresh_views();
  },
  watch: {
    project_date_range: {
      immediate: false,
      handler: function () {
        this.start_date = this.project_date_range["start_date"];
        this.end_date = this.project_date_range["end_date"];

        const start_date_tmp = new Date(this.start_date);
        const end_date_tmp = new Date(this.end_date);
        const dateDiff = this.subtractDates(end_date_tmp, start_date_tmp);
        const prevEndDate = this.addDays(start_date_tmp, -1);
        const prevStartDate = this.addDays(prevEndDate, -dateDiff);

        (this.compare_start_date = this.boundDate(
          prevStartDate,
          this.project_date_range["min_start_date"],
          this.project_date_range["max_end_date"]
        )),
          (this.compare_end_date = this.boundDate(
            prevEndDate,
            this.project_date_range["min_start_date"],
            this.project_date_range["max_end_date"]
          ));
        this.refresh_data();
      },
      deep: true,
    },
    data_levels: {
      immediate: false,
      handler: function () {
        this.available_data_levels = this.data_levels["data_levels"];
        if (
          this.selected_levels.toString() !=
          this.data_levels["selected_levels"].toString()
        ) {
          this.selected_levels = this.data_levels["selected_levels"];
          this.selected_levels_tmp = this.data_levels["selected_levels"];
          this.refresh_data();
        }
      },
      deep: true,
    },
  },
  computed: {
    data_fields: function () {
      let fields = [];
      if (this.performanceDataRaw == null) {
        return [];
      }
      for (let header_row of this.performanceDataRaw["table_headers"]) {
        if (!this.available_data_levels.includes(header_row["value"])) {
          fields.push(header_row["text"]);
        }
      }
      return fields;
    },
    sort_keys: function () {
      let sort_keys = [];
      for (let header_row of this.headers) {
        sort_keys.push(header_row["value"]);
      }
      return sort_keys;
    },
    headers: function () {
      let data_tbl_header = [];

      if (this.performanceDataRaw == null) {
        return [];
      }

      for (let header_row of this.performanceDataRaw["table_headers"]) {
        if (
          (this.selected_fields.length == 0 ||
            this.selected_fields.includes(header_row["text"])) &&
          !this.available_data_levels.includes(header_row["value"])
        ) {
          data_tbl_header.push(header_row);
          if (
            this.compare &&
            ![
              "avg_cpm",
              "cpc",
              "avg_cpc",
              "ctr",
              "avg_ctr",
              "reach",
              "frequency",
            ].includes(header_row["value"])
          ) {
            let header_row_tmp = { ...header_row };
            header_row_tmp["value"] = header_row_tmp["value"] + " change";
            header_row_tmp["text"] = header_row_tmp["text"] + " change";
            data_tbl_header.push(header_row_tmp);
          }
        }
      }

      this.selected_levels
        .slice()
        .reverse()
        .forEach((lvl) =>
          data_tbl_header.unshift(this.performanceDataRaw["table_levels"][lvl])
        );
      return data_tbl_header;
    },
  },
  methods: {
    exportPortfolioPages: function () {
      console.log("Exporting Portfolio Pages");
      this.$emit("export");
    },
    format_filter_val_output: function (filters) {
      let filter_str = "";
      for (let f of filters) {
        filter_str += f;
        filter_str += ", ";
      }
      return filter_str.slice(0, -2);
    },
    update_levels_debounce: debounce(function (value) {
      this.selected_levels = value;
      this.refresh_data(true);
    }, 1500),
    refresh_data: async function (emit_update = false) {
      this.tbl_avaialable = false;
      this.graph_export_ready = false;
      let date_range = {
        start_date: this.start_date,
        end_date: this.end_date,
      };
      let token = await this.$auth.getTokenSilently();
      let response = await api_caller
        .get_portfolio_data(
          token,
          this.$project.get_val(),
          date_range,
          this.data_filters,
          this.selected_levels
        )
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log("error", e);
          return false;
        });

      if (response && response["portfolio_data"]) {
        this.performanceDataRaw = response["portfolio_data"];
        this.performanceData = response["portfolio_data"]["table_content"];
        this.filter_base_values = response["portfolio_data"]["available_filter_vals"];
        this.data_filters = response["portfolio_data"]["data_filters"];

        if (this.compare) {
          await this.refresh_compare_data();
        }
        this.update_data_levels(emit_update);
        this.reset_table();
        this.graph_export_ready = true;
      }
    },
    process_portfolio_quarter_delta(portfolio_data, portfolio_data_prev_quarter) {
      let ads_unit_levels = Object.keys(portfolio_data["table_levels"]);
      function is_ads_unit(value) {
        for (let i = 0; i < ads_unit_levels.length; i++) {
          if (value[ads_unit_levels[i]] == null || value[ads_unit_levels[i]] == "") {
            return false;
          }
        }
        return true;
      }

      if (
        portfolio_data["table_content"] &&
        portfolio_data_prev_quarter["table_content"]
      ) {
        let table_metrics = [
          { value: "spend", text: "Spend" },
          { value: "roi", text: "ROI" },
          { value: "sales_attribution", text: "Sales Attribution" },
        ];

        let tmp_portfolio_data = { ...portfolio_data };
        tmp_portfolio_data["table_content"] = tmp_portfolio_data["table_content"].filter(
          is_ads_unit
        );

        let tmp_portfolio_data_prev_qrt = { ...portfolio_data_prev_quarter };
        tmp_portfolio_data_prev_qrt["table_content"] = tmp_portfolio_data_prev_qrt[
          "table_content"
        ].filter(is_ads_unit);

        let portfolio_data_delta = {
          table_headers: [],
          table_content: [],
          table_levels: ads_unit_levels,
          table_metrics: table_metrics,
        };
        portfolio_data_delta["table_headers"] = ads_unit_levels.concat(
          table_metrics.map((a) => a.value)
        );

        for (let i = 0; i < tmp_portfolio_data["table_content"].length; i++) {
          let row = {};
          ads_unit_levels.forEach((level) => {
            row[level] = tmp_portfolio_data["table_content"][i][level];
          });
          if (
            tmp_portfolio_data["table_content"][i] &&
            tmp_portfolio_data_prev_qrt["table_content"][i]
          ) {
            let old_data = tmp_portfolio_data_prev_qrt["table_content"][i];
            let new_data = tmp_portfolio_data["table_content"][i];
            row["spend"] = {
              value: new_data["spend"] - old_data["spend"],
              percentage:
                old_data["spend"] == 0
                  ? 0
                  : (new_data["spend"] - old_data["spend"]) / old_data["spend"],
            };
            row["roi"] = {
              value: new_data["roi"] - old_data["roi"],
              percentage:
                old_data["roi"] == 0
                  ? 0
                  : (new_data["roi"] - old_data["roi"]) / old_data["roi"],
            };
            row["sales_attribution"] = {
              value: new_data["sales_attribution"] - old_data["sales_attribution"],
              percentage:
                old_data["sales_attribution"] == 0
                  ? 0
                  : (new_data["sales_attribution"] - old_data["sales_attribution"]) /
                    old_data["sales_attribution"],
            };
            portfolio_data_delta["table_content"].push(row);
          }
        }
        this.$emit("portfolio_quarter_delta_update", portfolio_data_delta);
      }
    },
    refresh_compare_data: async function () {
      this.tbl_avaialable = false;
      let date_range = {
        start_date: this.compare_start_date,
        end_date: this.compare_end_date,
      };
      let token = await this.$auth.getTokenSilently();
      let portfolio_data = await api_caller
        .get_portfolio_data(
          token,
          this.$project.get_val(),
          date_range,
          this.data_filters,
          this.selected_levels
        )
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log("error", e);
          return false;
        });
      if (!portfolio_data) {
        this.compareDataRaw = null;
        this.update_data_levels(false);
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
        return;
      } else {
        this.compareDataRaw = portfolio_data["portfolio_data"];
        this.update_data_levels(false);
      }
      this.reset_table();
    },
    refresh_views: async function () {
      this.views_loading = true;
      let token = await this.$auth.getTokenSilently();
      let saved_views = await info_caller
        .get_saved_views(token, this.$project.get_val())
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log("error", e);
          return false;
        });
      if (!saved_views) {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
        return;
      }
      this.available_views = saved_views["views"];
      this.views_loading = false;
    },
    reset_table: function () {
      this.tbl_avaialable = false;
      setTimeout(() => (this.tbl_avaialable = true), 100);
    },
    // sort_table: function () {
    //   return;
    // },
    handle_row_click: function (value) {
      let channel = {
        data_levels: [],
        data_query: [],
      };
      let levels = [];
      for (let level of this.selected_levels) {
        if (value[level]) {
          channel["data_query"].push({
            level: level,
            value: value[level],
          });
          levels.push(level);
        } else {
          return;
        }
      }
      channel["data_levels"] = levels;
      this.$emit("switch_tab", "graph", channel);
    },
    level_val: function (item, col) {
      let idx = this.selected_levels.indexOf(col);
      let hide = false;
      for (let i = this.selected_levels.length - 1; i > idx; i--) {
        if (item[this.selected_levels[i]] != null) {
          hide = true;
        }
      }
      if (hide) {
        return "";
      } else {
        return item[col];
      }
    },
    update_data_levels: function (emit_update) {
      if (this.performanceDataRaw == null) {
        this.performanceData = [];
        return;
      }
      this.performanceData = this.filter_dataset(
        this.performanceDataRaw["table_content"]
      );
      if (this.compare) {
        let compare_data = this.filter_dataset(this.compareDataRaw["table_content"]);
        for (let idx = 0; idx < this.performanceData.length; idx++) {
          let row_id = null;
          for (let cdx = 0; cdx < compare_data.length; cdx++) {
            for (let level of this.selected_levels) {
              if (!(compare_data[cdx][level] === this.performanceData[idx][level])) {
                row_id = null;
                break;
              } else {
                row_id = cdx;
              }
            }
            if (row_id != null) {
              break;
            }
          }
          if (row_id == null) {
            this.performanceData[idx]["enrollments compare"] = 0;
            this.performanceData[idx]["enrollments change"] = 0;
            this.performanceData[idx]["cpe compare"] = 0;
            this.performanceData[idx]["cpe change"] = 0;
            this.performanceData[idx]["roi compare"] = 0;
            this.performanceData[idx]["roi change"] = 0;
            this.performanceData[idx]["cpu compare"] = 0;
            this.performanceData[idx]["cpu change"] = 0;
            this.performanceData[idx]["units compare"] = 0;
            this.performanceData[idx]["units change"] = 0;
            this.performanceData[idx]["spend compare"] = 0;
            this.performanceData[idx]["spend change"] = 0;
            this.performanceData[idx]["impressions compare"] = 0;
            this.performanceData[idx]["impressions change"] = 0;
            this.performanceData[idx]["clicks compare"] = 0;
            this.performanceData[idx]["clicks change"] = 0;
            this.performanceData[idx]["cpm compare"] = 0;
            this.performanceData[idx]["cpm compare"] = 0;
          } else {
            if (Object.keys(compare_data[row_id]).includes("enrollments")) {
              this.performanceData[idx]["enrollments compare"] =
                compare_data[row_id]["enrollments"];
              this.performanceData[idx]["enrollments change"] =
                this.performanceData[idx]["enrollments"] == 0 ||
                this.performanceData[idx]["enrollments"] == 0
                  ? 0
                  : (this.performanceData[idx]["enrollments"] -
                      this.performanceData[idx]["enrollments compare"]) /
                    this.performanceData[idx]["enrollments compare"];
            }
            if (Object.keys(compare_data[row_id]).includes("cpe")) {
              this.performanceData[idx]["cpe compare"] = compare_data[row_id]["cpe"];
              this.performanceData[idx]["cpe change"] =
                this.performanceData[idx]["cpe"] == 0 ||
                this.performanceData[idx]["cpe"] == 0
                  ? 0
                  : (this.performanceData[idx]["cpe"] -
                      this.performanceData[idx]["cpe compare"]) /
                    this.performanceData[idx]["cpe compare"];
            }

            this.performanceData[idx]["roi compare"] = compare_data[row_id]["roi"];
            this.performanceData[idx]["roi change"] =
              this.performanceData[idx]["roi"] == 0 ||
              this.performanceData[idx]["roi"] == 0
                ? 0
                : (this.performanceData[idx]["roi"] -
                    this.performanceData[idx]["roi compare"]) /
                  this.performanceData[idx]["roi compare"];
            
            this.performanceData[idx]["cpu compare"] = compare_data[row_id]["cpu"];
            this.performanceData[idx]["cpu change"] =
              this.performanceData[idx]["cpu"] == 0 ||
              this.performanceData[idx]["cpu"] == 0
                ? 0
                : (this.performanceData[idx]["cpu"] -
                    this.performanceData[idx]["cpu compare"]) /
                  this.performanceData[idx]["cpu compare"];
            
            this.performanceData[idx]["units compare"] = compare_data[row_id]["units"];
            this.performanceData[idx]["units change"] =
              this.performanceData[idx]["units"] == 0 ||
              this.performanceData[idx]["units"] == 0
                ? 0
                : (this.performanceData[idx]["units"] -
                    this.performanceData[idx]["units compare"]) /
                  this.performanceData[idx]["units compare"];

            this.performanceData[idx]["spend compare"] = compare_data[row_id]["spend"];
            this.performanceData[idx]["spend change"] =
              this.performanceData[idx]["spend"] == 0 ||
              this.performanceData[idx]["spend"] == 0
                ? 0
                : (this.performanceData[idx]["spend"] -
                    this.performanceData[idx]["spend compare"]) /
                  this.performanceData[idx]["spend compare"];

            this.performanceData[idx]["impressions compare"] =
              compare_data[row_id]["impressions"];
            this.performanceData[idx]["impressions change"] =
              this.performanceData[idx]["impressions"] == 0 ||
              this.performanceData[idx]["impressions"] == 0
                ? 0
                : (this.performanceData[idx]["impressions"] -
                    this.performanceData[idx]["impressions compare"]) /
                  this.performanceData[idx]["impressions compare"];

            this.performanceData[idx]["sales_attribution compare"] =
              compare_data[row_id]["sales_attribution"];
            this.performanceData[idx]["sales_attribution change"] =
              this.performanceData[idx]["sales_attribution"] == 0 ||
              this.performanceData[idx]["sales_attribution"] == 0
                ? 0
                : (this.performanceData[idx]["sales_attribution"] -
                    this.performanceData[idx]["sales_attribution compare"]) /
                  this.performanceData[idx]["sales_attribution compare"];

            this.performanceData[idx]["clicks compare"] = compare_data[row_id]["clicks"];
            this.performanceData[idx]["clicks change"] =
              this.performanceData[idx]["clicks"] == 0 ||
              this.performanceData[idx]["clicks"] == 0
                ? 0
                : (this.performanceData[idx]["clicks"] -
                    this.performanceData[idx]["clicks compare"]) /
                  this.performanceData[idx]["clicks compare"];

            this.performanceData[idx]["cpm compare"] = compare_data[row_id]["cpm"];
            this.performanceData[idx]["cpm change"] =
              this.performanceData[idx]["cpm"] == 0 ||
              this.performanceData[idx]["cpm"] == 0
                ? 0
                : (this.performanceData[idx]["cpm"] -
                    this.performanceData[idx]["cpm compare"]) /
                  this.performanceData[idx]["cpm compare"];
          }
        }
      }

      let level_values = [];
      let level_name = "";
      let valid = false;

      for (let row of this.performanceData) {
        level_name = "";
        valid = true;
        for (let l of this.selected_levels) {
          if (row[l]) {
            level_name += row[l];
          } else {
            valid = false;
          }
          if (row[l] != null) {
            level_name += "__";
          }
        }
        if (valid) {
          level_values.push(level_name.slice(0, -2));
        }
      }
      if (emit_update || this.data_levels["level_values"].length == 0) {
        this.$emit("level_update", {
          data_levels: this.available_data_levels,
          selected_levels: this.selected_levels,
          level_values: level_values,
          data_filters: this.data_filters,
          filter_base_values: this.filter_base_values,
        });
      }
    },
    filter_added(filter) {
      this.data_filters = filter;
      this.refresh_data(true);
      this.$emit("filter_update", this.data_filters);
    },
    filter_dataset(data) {
      let data_rows = [];
      let level_idxs = {};
      let include = false;
      let include_sub = false;
      let num_levels = this.selected_levels.length;
      let i = 0;
      for (let level of this.selected_levels) {
        level_idxs[level] = i;
        i++;
      }
      for (let row of data) {
        include = true;
        for (let level of this.available_data_levels) {
          //group rows
          if (!this.selected_levels.includes(level) && row[level] != null) {
            include = false;
          }
        }
        include_sub = true;
        i = 0;
        for (i = 0; i < num_levels; i++) {
          if (i == 0 && row[this.selected_levels[i]] == null) {
            include = false;
            break;
          } else if (row[this.selected_levels[i]] == null) {
            include_sub = false;
          } else if (include_sub == false && row[this.selected_levels[i]] != null) {
            include = false;
            break;
          }
          if (this.selected_levels[i] in this.data_filters) {
            if (
              !this.data_filters[this.selected_levels[i]].includes(
                row[this.selected_levels[i]]
              ) &&
              row[this.selected_levels[i]] != null
            ) {
              include = false;
              break;
            }
          }
        }
        if (include) {
          data_rows.push(row);
        }
      }
      return data_rows;
    },
    // Dashboard Date Changes
    update_start_date(date) {
      this.selected_view = null;
      this.$emit("date_update", { start_date: date, end_date: this.end_date });
    },
    update_end_date(date) {
      this.selected_view = null;
      this.$emit("date_update", { start_date: this.start_date, end_date: date });
    },
    update_date(date, prev_date_range) {
      this.selected_view = null;
      this.$emit("date_update", { start_date: date[0], end_date: date[1] });

      if (prev_date_range && prev_date_range.length > 0) {
        this.compare_start_date = prev_date_range[0];
        this.compare_end_date = prev_date_range[1];
        this.refresh_compare_data();
      }
    },
    update_compare_start(date) {
      this.compare_start_date = date;
      this.selected_view = null;
      this.refresh_compare_data();
    },
    update_compare_end(date) {
      this.compare_end_date = date;
      this.selected_view = null;
      this.refresh_compare_data();
    },
    update_compare_date(date) {
      this.compare_start_date = date[0];
      this.compare_end_date = date[1];
      this.selected_view = null;
      this.refresh_compare_data();
    },
    // Bookmark Functions
    open_view: async function (view) {
      let data_view = this.available_views[view];
      if (data_view["compare"]) {
        this.compare = data_view["compare"];
        this.compare_start_date = data_view["compare_start_date"];
        this.compare_end_date = data_view["compare_end_date"];
        await this.refresh_compare_data();
      } else {
        this.compare = data_view["compare"];
        this.compare_start_date = data_view["compare_start_date"];
        this.compare_end_date = data_view["compare_end_date"];
      }
      this.selected_fields = data_view["fields"];
      this.selected_levels = data_view["data_levels"];
      this.selected_levels_tmp = data_view["data_levels"];
      this.data_filters = data_view["data_filters"];

      this.$emit("filter_update", this.data_filters);
      this.$emit("date_update", {
        start_date: data_view["start_date"],
        end_date: data_view["end_date"],
      });

      this.refresh_data(true);
      this.selected_view = view;
    },
    save_view_func: function () {
      this.save_view = true;
    },
    close_save_view_func: function () {
      this.save_view = false;
      this.view_name_tmp = "";
    },
    add_view: async function () {
      let token = await this.$auth.getTokenSilently();
      let view = {
        name: this.view_name_tmp,
        start_date: this.start_date,
        end_date: this.end_date,
        data_levels: this.selected_levels.join("|"),
        compare: this.compare,
        compare_start_date: this.compare_start_date,
        compare_end_date: this.compare_end_date,
        fields: this.selected_fields,
        data_filters: this.data_filters,
      };
      await info_caller.add_view(token, this.$project.get_val(), view);
      this.view_name_tmp = "";
      this.save_view = false;
      await this.refresh_views();
      this.selected_view = this.available_views.length - 1;
    },
    delete_view: async function (view) {
      this.views_loading = true;
      let token = await this.$auth.getTokenSilently();
      await info_caller.delete_view(token, this.$project.get_val(), view);
      this.refresh_views();
    },
    reset_view: function () {
      // let data_view = this.available_views[view];
      this.compare = false;
      this.selected_fields = [
        "ROI",
        "Sales Attribution",
        "Spend",
        "Impressions",
        "CPM",
        "Avg Daily CPM",
        "Clicks",
        "CPC",
        "Avg Daily CPC",
        "CTR",
        "Avg Daily CTR",
        "Reach",
        "Frequency",
      ];
      this.data_filters = this.available_filter_vals;
      this.selected_levels = [this.available_data_levels[0]];
      this.selected_levels_tmp = [this.available_data_levels[0]];

      this.$emit("filter_update", this.data_filters);

      this.refresh_data(true);
      this.selected_view = null;
    },

    get_data_row_color: function (item) {
      let grey_notches = ["FFFFFF", "F0F0F0", "DCDCDC", "D0D0D0", "BEBEBE", "A9A9A9"];
      let null_count = 0;
      for (let level of this.selected_levels) {
        if (item[level] == null) {
          null_count++;
        }
      }
      return grey_notches[null_count];
    },

    exportExcel: async function () {
      console.log("Exporting Excel");

      const workbook = new ExcelJS.Workbook();

      workbook.creator = this.$auth.user.name;
      workbook.lastModifiedBy = this.$auth.user.name;
      workbook.created = new Date();
      workbook.modified = new Date();

      workbook.views = [
        {
          x: 0,
          y: 0,
          width: 10000,
          height: 20000,
          firstSheet: 0,
          activeTab: 1,
          visibility: "visible",
        },
      ];

      const worksheet = workbook.addWorksheet("Performance Data");
      worksheet.pageSetup.showRowColHeaders = true;

      let numberFormat = "";
      worksheet.columns = this.headers.map((header) => {
        if (this.currencyColumns.includes(header.value)) {
          numberFormat = '"$"#,##0.00';
        } else if (this.numericColumns.includes(header.value)) {
          numberFormat = "#,##0";
        } else if (this.percentageColumns.includes(header.value)) {
          numberFormat = "0.00%";
        } else {
          numberFormat = "";
        }
        return {
          header: header.text,
          key: header.value,
          width: 15,
          style: { numFmt: numberFormat },
        };
      });

      const sortedData = this.sortDataTableLevels(this.performanceData, "en-US");

      let rowColor = "";
      sortedData.forEach((row) => {
        let rowData = {};
        this.headers.forEach((header) => {
          if (header.value in row) {
            rowData[header.value] = row[header.value] ? row[header.value] : "n/a";
          } else {
            rowData[header.value] = "n/a";
          }
        });
        worksheet.addRow(rowData);

        const row2 = worksheet.getRow(worksheet.rowCount);
        rowColor = this.get_data_row_color(row);
        row2.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: rowColor }, // Yellow color (ARGB format)
          };
        });
      });

      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], { type: this.blobType });
        FileSaver.saveAs(blob, "Docma Performance Table.xlsx");
      });
    },

    chartsLoaded: async function () {
      while (!this.graph_export_ready) {
        await DELAY(EXPORT_DELAY_IN_MS);
        console.log("Graph Visible", this.graph_visible);
      }
      return true;
    },

    update_export_ready: function (value) {
      this.graph_export_ready = value;
    },

    build_export_pages: async function () {
      let portfolioExportElements = {
        portfolio_tables: [],
        portfolio_charts: [],
      };

      this.portfolio_type = "portfolio";
      this.$emit("update_export_message", EXPORT_MESSAGE_PORTFOLIO);
      await DELAY(EXPORT_DELAY_IN_MS);

      this.graph_export_ready = false;

      if (this.performanceData === undefined || this.performanceData.length == 0) {
        await this.chartsLoaded();
      }

      // adding table element
      let table_element = {
        table_name: "Portfolio Data",
        table_headers: this.headers,
        table_data: this.performanceData,
      };
      portfolioExportElements["portfolio_tables"].push(table_element);

      this.portfolio_type = "performance";
      this.$emit("update_export_message", EXPORT_MESSAGE_PERFORMANCE);
      this.chart_update_key++;
      await DELAY(EXPORT_DELAY_IN_MS);

      // adding chart elements
      const performance_overview_element = this.$refs["performance_overview"];

      if (!performance_overview_element.tbl_avaialable) {
        await this.chartsLoaded();
      }

      let chart_data = null;
      let chart_image = null;
      let new_chart_element = null;
      let inner_chart_components = null;
      let chart_elements = [];
      for (let element in performance_overview_element.$refs) {
        // chart element is in the performance overview component level
        if (element in this.chart_mapping) {
          chart_data = echarts.getInstanceByDom(
            document.getElementById(this.chart_mapping[element]["chart_id"])
          );
          chart_image = chart_data.getDataURL({
            type: "svg", // You can change the image type here
            pixelRatio: 5, // Adjust the pixel ratio for higher resolution
          });

          new_chart_element = {
            chart_ref: element,
            chart_name: this.chart_mapping[element]["chart_name"],
            chart_image: chart_image,
          };

          if (element == this.chart_mapping["portfolio_sos_chart"]["chart_ref"]) {
            new_chart_element["chart_data"] =
              performance_overview_element["sales_summary"];
          }

          chart_elements.push(new_chart_element);
        } else {
          // reach in one more level into the component wrapper to get the chart
          inner_chart_components = performance_overview_element.$refs[element];

          for (let element2 in inner_chart_components.$refs) {
            if (element2 in this.chart_mapping) {
              chart_data = echarts.getInstanceByDom(
                document.getElementById(this.chart_mapping[element2]["chart_id"])
              );
              chart_image = chart_data.getDataURL({
                type: "svg", // You can change the image type here
                pixelRatio: 5, // Adjust the pixel ratio for higher resolution
              });

              new_chart_element = {
                chart_ref: element2,
                chart_name: this.chart_mapping[element2]["chart_name"],
                chart_image: chart_image,
              };

              if (
                element2 ==
                this.chart_mapping["portfolio_time_series_comparison_chart"]["chart_ref"]
              ) {
                new_chart_element["chart_data"] = inner_chart_components["datasetb"];
              }
              chart_elements.push(new_chart_element);
            }
          }
        }
      }
      portfolioExportElements["portfolio_charts"] = chart_elements;

      this.portfolio_type = "portfolio";
      await DELAY(EXPORT_DELAY_IN_MS);

      return portfolioExportElements;
    },

    exportSelected: function (id) {
      const selectedExportItem = id;
      if (selectedExportItem == "export_pptx") {
        this.exportPortfolioPages();
      } else if (selectedExportItem == "export_xlsx") {
        this.exportExcel();
      }
    },

    sortDataTableLevels(items, locale) {
      let sortBy = [...this.selected_levels];
      let sortDesc = [];
      for (let i = 0; i < this.selected_levels.length; i++) {
        sortDesc.push(false);
      }

      // Define a comparator function
      const comparator = (a, b, key, descending) => {
        let valueA = a[key];
        let valueB = b[key];
        let result = 0;

        let isSelectedLevel = this.selected_levels.includes(key);

        if (valueA == null && valueB == null) {
          result = 0;
        } else if (valueA == null) {
          result = isSelectedLevel ? -1 : 1;
          return result;
        } else if (valueB == null) {
          result = isSelectedLevel ? 1 : -1;
          return result;
        } else {
          if (typeof valueA === "string" && typeof valueB === "string") {
            result = valueA.localeCompare(valueB, locale, { numeric: true });
          } else if (typeof valueA === "number" && typeof valueB === "number") {
            result = valueA - valueB;
          } else if (valueA instanceof Date && valueB instanceof Date) {
            result = valueA - valueB;
          } else {
            result = String(valueA).localeCompare(String(valueB), locale, {
              numeric: true,
            });
          }
        }
        // Adjust for descending order
        return descending ? -result : result;
      };

      if (this.selected_levels.length > 1) {
        const groupItems = (items, selected_levels) => {
          // Helper function to create the hierarchical structure
          const createHierarchy = (items, levels) => {
            if (levels.length === 0) {
              return [];
            }

            const level = levels[0];
            const grouped = items.reduce((acc, item) => {
              const key = item[level];
              if (key === undefined) return acc;

              if (!acc[key]) {
                acc[key] = [];
              }
              acc[key].push(item);
              return acc;
            }, {});

            return Object.keys(grouped).map((key) => {
              const children = createHierarchy(grouped[key], levels.slice(1));
              return {
                parent: { ...grouped[key][0], [level]: key },
                children,
              };
            });
          };

          return createHierarchy(items, selected_levels);
        };
        // Group and sort the items
        let groupedItems = groupItems(items, this.selected_levels);

        // Function to sort the groups and their children
        const sortGroups = (groupedItems, sortBy, sortDesc) => {
          groupedItems.sort((a, b) => {
            for (let i = 0; i < sortBy.length; i++) {
              const key = sortBy[i];
              const descending = sortDesc[i];

              const result = comparator(a.parent, b.parent, key, descending);
              if (result !== 0) return result;
            }
            return 0;
          });

          groupedItems.forEach((group) => {
            if (group.children && group.children.length > 0) {
              // Recursively sort subgroups
              sortGroups(group.children, sortBy, sortDesc);
            }
          });
        };

        sortGroups(groupedItems, sortBy, sortDesc);

        // Flatten the groupedItems array recursively to get the final sorted list
        const flattenGroups = (groupedItems) => {
          return groupedItems.reduce((acc, group) => {
            if (group.parent) acc.push(group.parent);
            return acc.concat(flattenGroups(group.children));
          }, []);
        };

        const sortedItems = flattenGroups(groupedItems);

        return sortedItems;
      } else {
        // Sort the items array
        items.sort((a, b) => {
          for (let i = 0; i < sortBy.length; i++) {
            const key = sortBy[i];
            const descending = sortDesc[i];

            const result = comparator(a, b, key, descending);
            if (result !== 0) return result;
          }
          return 0; // If all comparisons are equal
        });
      }

      return items;
    },
    subtractDates(date1, date2) {
      const oneDay = 24 * 60 * 60 * 1000; // milliseconds in one day
      const diffInMilliseconds = date1.getTime() - date2.getTime();
      return Math.round(diffInMilliseconds / oneDay); // Convert milliseconds to days
    },
    addDays(date, days) {
      const newDate = new Date(date);
      newDate.setDate(date.getDate() + days);
      return newDate;
    },
    boundDate(date, minDate, maxDate) {
      const min = new Date(minDate);
      const max = new Date(maxDate);
      return date < min
        ? min.toISOString().substr(0, 10)
        : date > max
        ? max.toISOString().substr(0, 10)
        : date.toISOString().substr(0, 10);
    },
  },
};
</script>

<style>
.table-title {
  font-family: "Poppins" !important;
  font-weight: 600;
  font-size: 1.5em;
}
.performance_section_title {
  font-family: "Poppins" !important;
  font-weight: 500;
  font-size: 0.9 em;
}
.toolbar_title {
  font-family: "Poppins" !important;
  font-weight: 600;
  font-size: 1.1em;
}
.toolbar_selector {
  font-family: "Poppins" !important;
  font-weight: 400;
  font-size: 0.9 em;
}
.v-list-item .v-list-item__title {
  font-family: "Poppins" !important;
  font-weight: 400;
  font-size: 0.85em;
}

.filter_title {
  font-family: "Poppins";
  font-weight: 600;
  font-size: 1em;
}
.filter_vals {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 0.9em;
}
</style>
